import {filter, lazy} from './lang.js';
import {doc} from './documentation.js';

doc(
    "gte",
    {
        a: "Argument 1",
        b: "Argument 2"
    },
    "Returns true if a >= b"
);
export const gte = (a, b) => {
    return (...args) => {
        let _a = lazy(a, ...args);
        let _b = lazy(b, ...args);
        return filter(_a >= _b);
    };
};


doc(
    "lte",
    {
        a: "Argument 1",
        b: "Argument 2"
    },
    "Returns true if a <= b"
);
export const lte = (a, b) => {
    return (...args) => {
        return filter(lazy(a, ...args) <= lazy(b, ...args));
    };
};

